/* Molten bronze shader, used twice: the hero (slow liquid bronze that follows the light of the mouse)
   and the craft chapter (wax, clay, fire, bronze, driven by scroll, unchanged from the earlier version). */
import * as THREE from 'three';

const U = window.UMOJA || {heroP:0, waxP:0, mouse:{x:.5,y:.5}};
const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
const small = innerWidth < 860;

function hasGL(){ try { const c = document.createElement('canvas'); return !!(c.getContext('webgl2') || c.getContext('webgl')); } catch(e){ return false; } }

const FRAG = `
  precision highp float; varying vec2 v; uniform float uT,uS,uDim; uniform vec2 uR,uM;
  float h(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}
  float n(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);return mix(mix(h(i),h(i+vec2(1,0)),f.x),mix(h(i+vec2(0,1)),h(i+1.),f.x),f.y);}
  float fbm(vec2 p){float s=0.,a=.5;for(int i=0;i<6;i++){s+=a*n(p);p=p*2.03+vec2(1.7,9.2);a*=.5;}return s;}
  vec3 wax(vec2 p){float f=fbm(p*2.+uT*.05);vec3 c=mix(vec3(.55,.42,.24),vec3(.86,.72,.46),f);return c*(.75+.35*fbm(p*7.));}
  vec3 clay(vec2 p){float f=fbm(p*3.5);float cr=smoothstep(.48,.5,abs(fbm(p*5.+3.)-.5)*2.);vec3 c=mix(vec3(.26,.14,.08),vec3(.48,.27,.15),f);return c*(1.-cr*.35)*(.8+.3*n(p*90.));}
  vec3 fire(vec2 p){vec2 q=vec2(fbm(p*1.6+vec2(0.,-uT*.35)),fbm(p*1.6+vec2(5.2,-uT*.3)));float f=fbm(p*2.2+q*2.4+vec2(0.,-uT*.25));vec3 c=mix(vec3(.05,.01,0.),vec3(.6,.08,.01),smoothstep(.2,.55,f));c=mix(c,vec3(1.,.45,.08),smoothstep(.5,.75,f));c=mix(c,vec3(1.,.86,.5),smoothstep(.72,.9,f));return c;}
  vec3 brz(vec2 p){float f=fbm(p*vec2(1.2,4.)+uT*.03);float hl=pow(max(0.,1.-length((v-uM)*vec2(uR.x/uR.y,1.))*1.4),3.);vec3 c=mix(vec3(.08,.045,.025),vec3(.42,.25,.12),f);c+=vec3(.9,.58,.3)*hl*(.4+.6*f);float st=pow(abs(sin(p.y*14.+f*6.)),24.);return c+st*vec3(.18,.1,.05);}
  void main(){vec2 p=v*vec2(uR.x/uR.y,1.)*1.6;float s=uS;
    vec3 c=wax(p);c=mix(c,clay(p),smoothstep(.6,1.2,s));c=mix(c,fire(p),smoothstep(1.6,2.2,s));c=mix(c,brz(p),smoothstep(2.6,3.,s));
    float vig=smoothstep(1.25,.25,length(v-.5));c*=mix(.35,1.,vig);c*=mix(1.,.55,smoothstep(.35,.0,v.y));
    gl_FragColor=vec4(pow(c*uDim,vec3(.95)),1.);}`;

function molten(canvas, stage){
  const renderer = new THREE.WebGLRenderer({canvas, antialias:false, powerPreference:'high-performance'});
  renderer.setPixelRatio(Math.min(devicePixelRatio, small ? 1 : 1.5));
  const scene = new THREE.Scene(), cam = new THREE.OrthographicCamera(-1,1,1,-1,0,1);
  const uni = {uT:{value:0}, uS:{value:0}, uDim:{value:1}, uR:{value:new THREE.Vector2(1,1)}, uM:{value:new THREE.Vector2(.5,.5)}};
  scene.add(new THREE.Mesh(new THREE.PlaneGeometry(2,2), new THREE.ShaderMaterial({uniforms:uni, vertexShader:'varying vec2 v;void main(){v=uv;gl_Position=vec4(position.xy,0.,1.);}', fragmentShader:FRAG})));
  const size = () => { const w = canvas.clientWidth, h = canvas.clientHeight; renderer.setSize(w, h, false); uni.uR.value.set(w, h); };
  size(); addEventListener('resize', size);
  let visible = false; new IntersectionObserver(([e]) => visible = e.isIntersecting).observe(canvas);
  const clock = new THREE.Clock(); let s = stage(0).s, mx = .5, my = .5, last = 0;
  renderer.setAnimationLoop(() => {
    if (!visible) return;
    const t = clock.getElapsedTime(), k = 1 - Math.exp(-Math.min(.25, t - last) * 5); last = t;
    const target = stage(t);
    s += (target.s - s) * k; mx += (U.mouse.x - mx)*k*.6; my += ((1.-U.mouse.y) - my)*k*.6;
    uni.uT.value = RM ? 0 : t; uni.uS.value = s; uni.uDim.value = target.dim; uni.uM.value.set(mx, my);
    renderer.render(scene, cam);
  });
}

if (hasGL()) {
  const hero = document.getElementById('heroGl');
  // hero: liquid bronze with veins of fire, breathing slowly; it dims as you scroll away
  if (hero) molten(hero, t => ({s: 2.72 + Math.sin(t*.12)*.18, dim: .9 - U.heroP*.5}));
  const melt = document.getElementById('melt');
  // craft chapter: wax, clay, fire, bronze, as you scroll
  if (melt) molten(melt, () => ({s: RM ? 0 : U.waxP*3.4, dim: 1}));
}
